goog.provide("shadow.js.shim.module$$mui$material$Grid");
goog.provide("module$shadow_js_shim_module$$mui$material$Grid");
shadow.js.shim.module$$mui$material$Grid = shadow.js.nativeProvides["@mui/material/Grid"] = shadow$bridge("@mui/material/Grid");
module$shadow_js_shim_module$$mui$material$Grid.default = shadow.js.shim.module$$mui$material$Grid;
